import dayjs, { ConfigType } from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);
dayjs.extend(timezone);

// 한국 표준시로 타임존 설정
const KST_TIMEZONE = 'Asia/Seoul';

export type DatetimeConfig = ConfigType;

/**
 * KST 기준으로 설정된 dayjs 인스턴스를 반환합니다
 *
 * @param date - 변환할 날짜 (옵션)
 * @returns KST 타임존이 적용된 dayjs 인스턴스
 * @example
 * ```typescript
 * // 현재 시간
 * const now = datetime();
 *
 * // 특정 날짜/시간
 * const someDate = datetime('2024-03-20');
 * const someDateTime = datetime('2024-03-20 15:30:00');
 * ```
 */
export const datetime = (date?: ConfigType) => {
  return dayjs(date).tz(KST_TIMEZONE);
};
